import "./header.less";
import { useAuth } from "../../auth/AuthContext";

const Header = (props) => {
  const { user } = useAuth();
  return (
    <section className="header">
      <div className="locate">
        <button className="menu-btn" onClick={props.click}>
          <svg viewBox="0 0 24 24"><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" /></svg>
        </button>
        <h1>{props.name}</h1>
      </div>
      <div className="options">
        <div className="user-tools">
          <svg viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" /></svg>
          {user?.email && <span>{user.email}</span>}
        </div>
      </div>
    </section>
  );
};

export default Header;
